export default __webpack_public_path__ + "static/media/boneshatter.e8e980f4.png";